<template>
  <el-dialog
    :title="isCreate ? '新增管理员' : '编辑管理员'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名" prop="adminName">
        <el-input
          v-model.trim="ruleForm.adminName"
          :readonly="!isCreate"
        ></el-input>
        <el-input style="position:fixed;bottom:-9999px"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model.trim="ruleForm.mobile"></el-input>
        <el-input style="position:fixed;bottom:-9999px"></el-input>
      </el-form-item>
      <el-checkbox v-if="!isCreate" v-model="checked">是否修改密码</el-checkbox>
      <template v-if="isCreate || checked">
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            maxlength="16"
            style="position:fixed;bottom:-9999px"
          ></el-input>
          <el-input v-model.trim="ruleForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repeatpassword">
          <el-input
            v-model.trim="ruleForm.repeatpassword"
            maxlength="16"
            type="password"
          ></el-input>
        </el-form-item>
      </template>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["isCreate", "userInfo"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("validatePass2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      ruleForm: {
        adminName: this.userInfo ? this.userInfo.adminName : "",
        mobile: this.userInfo ? this.userInfo.mobile : "",
        password: "",
        repeatpassword: "",
        role: 0
      },
      rules: {
        adminName: [{ required: true, message: "请输入用户名" }],
        password: [
          { required: true, validator: validatePass },
          {
            pattern: /^.*(?=.{6,16})(?=.*[0-9a-zA-Z]{1,})(?=.*[!@#$%^&*?()]).*$/,
            message: "密码必须6-16位，至少包含1个特殊字符(!@#$%^&*)"
          }
        ],
        repeatpassword: [{ required: true, validator: validatePass2 }],
        mobile: [
          { required: true, message: "请输入手机号码" },
          {
            validator: (rule, value, callback) => {
              if (!/^1\d{10}$/.test(value)) {
                return callback(new Error("请输入正确的手机号码"));
              } else {
                return callback();
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let queryModel = {
            adminName: this.ruleForm.adminName,
            password: this.ruleForm.password,
            mobile: this.ruleForm.mobile,
            role: this.ruleForm.role,
            id: this.userInfo ? this.userInfo.id : undefined
          };
          let key = this.isCreate ? "新增管理员" : "编辑管理员";
          this.$axios(this.$urlMapping[key], {
            data: queryModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$emit("closeForm");
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  }
};
</script>

<style lang="less" scoped></style>
